import { z } from 'zod';
import { PASSWORD_POLICY_RE } from './password-policy';

export const signupSchema = z
	.object({
		email: z.string(),
		password: z
			.string()
			.max(64, 'validation:auth.passwordLengthRule')
			.regex(PASSWORD_POLICY_RE, 'validation:auth.passwordRule'),
		passwordConfirm: z.string(),
		name: z
			.string()
			// Empty → required message; 1 char → min-length message (SHCT-339).
			.min(1, 'validation:name.required')
			.min(2, 'validation:name.minLength')
			.max(50, 'validation:name.maxLength')
			// SHCT-579 — 의료진 이름은 한글·영문 (공백 허용); 숫자·특수문자·이모지 불가
			// ([공통] 00 §2.5 / PRD 01 §4.1). Length checks run first so they win.
			.regex(/^[가-힣a-zA-Z ]+$/, 'validation:name.letters'),
		// PRD 01 §212·§220 / [공통] 00 §2.1 — 입력·검증·저장 모두 하이픈 없는 11자리, `010` 시작 고정.
		// Hyphens used to be optional here (`^010-?\d{4}-?\d{4}$`), which is the `HOLD-MW-01-06`
		// drift: the field does not strip them, so a typed `010-1234-5678` reached the BE in a shape
		// §220 forbids. The form now normalises to digits as they are typed, and this pattern is the
		// canonical one, so the two agree.
		phone: z.string().regex(/^010\d{8}$/, 'validation:phone.invalid010'),
		institution: z.string(),
		department: z.string(),
		role: z.string(),
		// US-SU-05: agreed termVersionIds. The form's submit gate enforces
		// all-required-checked (not the schema — the schema just carries the raw
		// selection; the gate + BE re-validate required-ness).
		agreedTermIds: z.array(z.number()),
	})
	.refine((data) => data.password === data.passwordConfirm, {
		message: 'validation:password.mismatch',
		path: ['passwordConfirm'],
	});

export type SignupFormValues = z.infer<typeof signupSchema>;
